import { render, staticRenderFns } from "./ImpactScoreTableCell.vue?vue&type=template&id=98d58ba0"
import script from "./ImpactScoreTableCell.vue?vue&type=script&lang=js"
export * from "./ImpactScoreTableCell.vue?vue&type=script&lang=js"
import style0 from "./ImpactScoreTableCell.vue?vue&type=style&index=0&id=98d58ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports